import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// CRM > Conversions — reads the read-only Admin_CRM_Conversions_Summary / _List procs
// via the Store WebAPI. Same token-refresh pattern as RTo3Service.
export default class ConversionsService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getSummary(fromDate, toDate, storeID, maxDays, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_CONVERSIONS_SUMMARY });
    let out = {};
    const payload = { fromDate: fromDate || null, toDate: toDate || null, storeID: storeID || 0, maxDaysAfterReg: maxDays || 0 };
    await api.endpoints[this.endpoint.GET_CONVERSIONS_SUMMARY]
      .getAllPost(payload)
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getSummary(fromDate, toDate, storeID, maxDays, true);
      } catch (e) {
        out = { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return out && out.data !== undefined ? out.data : out;
  }

  async getList(bucket, search, fromDate, toDate, storeID, pageIndex, pageSize, maxDays, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_CONVERSIONS_LIST });
    let out = [];
    const payload = {
      bucket: bucket || "1",
      search: search || "",
      fromDate: fromDate || null,
      toDate: toDate || null,
      storeID: storeID || 0,
      pageIndex: pageIndex || 1,
      pageSize: pageSize || 50,
      maxDaysAfterReg: maxDays || 0,
    };
    await api.endpoints[this.endpoint.GET_CONVERSIONS_LIST]
      .getAllPost(payload)
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getList(bucket, search, fromDate, toDate, storeID, pageIndex, pageSize, maxDays, true);
      } catch (e) {
        out = { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return out && out.data !== undefined ? out.data : out;
  }

  async getByOrderSummary(fromDate, toDate, storeID, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_CONVERSIONS_BYORDER_SUMMARY });
    let out = {};
    const payload = { fromDate: fromDate || null, toDate: toDate || null, storeID: storeID || 0 };
    await api.endpoints[this.endpoint.GET_CONVERSIONS_BYORDER_SUMMARY]
      .getAllPost(payload)
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });
    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getByOrderSummary(fromDate, toDate, storeID, true);
      } catch (e) { out = { statusCode: 401, message: "Session expired - please log in again." }; }
    }
    return out && out.data !== undefined ? out.data : out;
  }

  async getByOrderList(bucket, search, fromDate, toDate, storeID, pageIndex, pageSize, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_CONVERSIONS_BYORDER_LIST });
    let out = [];
    const payload = {
      bucket: bucket || "1", search: search || "", fromDate: fromDate || null,
      toDate: toDate || null, storeID: storeID || 0, pageIndex: pageIndex || 1, pageSize: pageSize || 50,
    };
    await api.endpoints[this.endpoint.GET_CONVERSIONS_BYORDER_LIST]
      .getAllPost(payload)
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });
    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getByOrderList(bucket, search, fromDate, toDate, storeID, pageIndex, pageSize, true);
      } catch (e) { out = { statusCode: 401, message: "Session expired - please log in again." }; }
    }
    return out && out.data !== undefined ? out.data : out;
  }

  async getTrend(storeID, months, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_CONVERSIONS_TREND });
    let out = [];
    const payload = { storeID: storeID || 0, months: months || 12 };
    await api.endpoints[this.endpoint.GET_CONVERSIONS_TREND]
      .getAllPost(payload)
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });
    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getTrend(storeID, months, true);
      } catch (e) { out = { statusCode: 401, message: "Session expired - please log in again." }; }
    }
    return out && out.data !== undefined ? out.data : out;
  }
}
